module.exports = __webpack_public_path__ + "img/nginx.183c992a.png";